import { render } from "./PaginationItems.vue?vue&type=template&id=003b3a79"
import script from "./PaginationItems.vue?vue&type=script&lang=js"
export * from "./PaginationItems.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__